import { useValidateTypescriptPropTypes } from '@elliemae/ds-props-helpers';
import type { WeakValidationMap } from 'react';
import { type DSFloatingWrapperT } from '../react-desc-prop-types.js';

export const useValidateProps = (
  props: DSFloatingWrapperT.InternalProps,
  propTypes: WeakValidationMap<unknown>,
): void => {
  useValidateTypescriptPropTypes(props, propTypes, 'FloatingWrapper');
};
